// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".background-overlay-outer-container{position:absolute;top:0;left:0;width:100vw;height:100vh;display:flex;align-items:center;justify-content:center;pointer-events:none}.background-div-overlay{position:absolute;top:0;left:0;width:100vw;height:100vh;background-color:#162b3e;mix-blend-mode:multiply}", ""]);
// Exports
module.exports = exports;
